import { Route } from "react-router-dom";
import { HolidayBundleScreen } from "./HolidayBundleScreen";

export const routes = (
  <Route path="holiday-bundle-2025" element={<HolidayBundleScreen />} />
);